<template>
  <div class="align-left shipping">
    <div v-if="allAddresses && allAddresses.length > 0" class="addresses">
      <ul class="shipping-list">
        <li
          v-for="(add, aIndex) in allAddresses"
          v-bind:key="aIndex"
          v-bind:class="{'selected' : addressEqual(add._id)}"
          @click="chooseAddress(add)"
        >
          <b-row>
            <b-col>
              {{add.givenNames}} {{add.lastNames}}
              <br>
              {{add.street}}
              <br>
              {{add.district}}
              <br>
              {{add.city}} {{add.state}} {{add.country}} {{add.zipCode}}
            </b-col>
          </b-row>
        </li>
      </ul>
    </div>
    <div v-else-if="!allAddresses || allAddresses.length <= 0">
      <div class="empty-info mb-2">
        <p>{{ $t('checkout.shipDet.emptyInfo') }}</p>
      </div>
      <a @click="gotoAccountManagement()">
        <font-awesome-icon icon="plus"/>&nbsp;&nbsp;
        {{ $t('checkout.shipDet.newAddr') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ShippingDetail',
  async created() {
    await this.$store.dispatch('accountStore/getAddresses');
    
    if (this.allAddresses.length > 0) {
      // If default adress is null, set the first address in allAddresses array as the selected one
      if (!this.defaultAddressId) {
        this.selectedAddressId = this.allAddresses[0]._id;
        this.$emit('selected', this.selectedAddressId)
      }
      else {
        // set default address as the selected one
        this.selectedAddressId = this.defaultAddressId;
        this.$emit('selected', this.selectedAddressId);
      }
    }
  },
  data() {
    return {
      selectedAddressId: null,
    };
  },

  methods: {
    gotoAccountManagement() {
      this.$router.push('/account');
    },

    addressEqual(addressId) {
      return _.isEqual(addressId, this.selectedAddressId);
    },

    chooseAddress(add) {
      this.selectedAddressId = add._id;
      this.$emit('selected', add._id);
    }
  },

  computed: {
    ...mapGetters({
      allAddresses: 'accountStore/getAddresses',
      defaultAddressId: 'accountStore/getDefaultAddressId',
      isSessionActive: 'authStore/isSessionActive',
    }),
  },
};
</script>

<style lang="scss" scoped>
.shipping-list {
  list-style-type: none;
  padding: 0px;
  margin-bottom: 20px;
  li {
    padding: 10px;
    padding-left: 1.2em;
    margin-bottom: 10px;
    border: 1px solid #dbdbdb;
    border-radius: 3px;

    &.selected {
      background: rgba(234,236,238, 0.8);
      border-left: 3px solid #5d6d7e;
      //border-radius: 5px;
    }

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
